<template>
    <div>
        <div class="modal fade"
             id="crew-activity-comment"
             tabindex="-1" role="dialog"
             aria-labelledby="crew-activity-comment-label"
             aria-hidden="true"
        >
            <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title font-weight-bolder" id="crew-activity-comment-label">
                            Crew Activity Comment
                        </h5>
                        <button type="button" id="close-crew-activity-comment" class="close"
                                data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-lg-4 p-0 m-0">
                                <p class="w-100 bg-silver p-1 font-weight-bold text-center">Act/Vessel</p>
                                <div class="form-group form-row mb-1">
                                    <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="activity-code" >
                                        Activity Code:
                                    </label>
                                    <div class="col col-sm-7">
                                        <input type="text" id="activity-code" readonly
                                               class="form-control form-control-xs form-display"
                                               :value="crewActivity.activityCode"
                                        >
                                    </div>
                                </div>

                                <div class="form-group form-row mb-1">
                                    <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="activity-rank" >
                                        Rank:
                                    </label>

                                    <div class="col col-sm-7">
                                        <input type="text" id="activity-rank" readonly
                                               class="form-control form-control-xs form-display"
                                               :value="crewActivity.rank"
                                        >
                                    </div>
                                </div>

                                <div class="form-group form-row mb-1">
                                    <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="activity-vessel" >
                                        Vessel:
                                    </label>

                                    <div class="col col-sm-7">
                                        <input type="text" id="activity-vessel" readonly
                                               class="form-control form-control-xs form-display"
                                               :value="crewActivity.vessel"
                                        >
                                    </div>
                                </div>
                            </div>
                            <div class="col col-lg-4 p-0 m-0">
                                <p class="w-100 bg-silver p-1 font-weight-bold text-center">Start/Embarkation</p>
                                <div class="form-group form-row mb-1">
                                    <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="activity-start-date" >
                                        Start Date:
                                    </label>
                                    <div class="col col-sm-7">
                                        <input type="text" id="activity-start-date" readonly
                                               class="form-control form-control-xs form-display"
                                               :value="crewActivity.startDate"
                                        >
                                    </div>
                                </div>

                                <div class="form-group form-row mb-1">
                                    <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="activity-start-status" >
                                        Start Status:
                                    </label>

                                    <div class="col col-sm-7">
                                        <input type="text" id="activity-start-status" readonly
                                               class="form-control form-control-xs form-display"
                                               :value="crewActivity.startStatus"
                                        >
                                    </div>
                                </div>

                                <div class="form-group form-row mb-1">
                                    <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="activity-start-port" >
                                        Start Port:
                                    </label>

                                    <div class="col col-sm-7">
                                        <input type="text" id="activity-start-port" readonly
                                               class="form-control form-control-xs form-display"
                                               :value="crewActivity.startPort"
                                        >
                                    </div>
                                </div>
                            </div>
                            <div class="col col-lg-4 p-0 m-0">
                                <p class="w-100 bg-silver p-1 font-weight-bold text-center">End/Embarkation</p>
                                <div class="form-group form-row mb-1">
                                    <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="activity-end-date" >
                                        End Date:
                                    </label>
                                    <div class="col col-sm-7">
                                        <input type="text" id="activity-end-date" readonly
                                               class="form-control form-control-xs form-display"
                                               :value="crewActivity.endDate"
                                        >
                                    </div>
                                </div>

                                <div class="form-group form-row mb-1">
                                    <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="activity-end-status" >
                                        End Status:
                                    </label>

                                    <div class="col col-sm-7">
                                        <input type="text" id="activity-end-status" readonly
                                               class="form-control form-control-xs form-display"
                                               :value="crewActivity.endStatus"
                                        >
                                    </div>
                                </div>

                                <div class="form-group form-row mb-1">
                                    <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="activity-end-port" >
                                        End Port:
                                    </label>

                                    <div class="col col-sm-7">
                                        <input type="text" id="activity-end-port" readonly
                                               class="form-control form-control-xs form-display"
                                               :value="crewActivity.endPort"
                                        >
                                    </div>
                                </div>

                                <div class="form-group form-row mb-1">
                                    <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="activity-end-reason" >
                                        End Reason:
                                    </label>

                                    <div class="col col-sm-7">
                                        <input type="text" id="activity-end-reason" readonly
                                               class="form-control form-control-xs form-display"
                                               :value="crewActivity.endReason"
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />

                        <template>
                            <h5 class="font-weight-bolder mt-3">New Comment</h5>

                            <form class="text-smaller" @submit.prevent="confirmAddCrewActivityComment">
                                <div class="row">
                                    <div class="col col-sm-8">
                                        <div class="form-group form-row mb-1 mt-1">
                                        <textarea rows="4"
                                                  class="form-control form-control-sm form-control-xs mb-2"
                                                  placeholder="Write New Comment Here"
                                                  v-model="newComment"
                                        ></textarea>
                                        </div>
                                    </div>
                                    <div class="col col-sm-4">
                                        <div class="form-group form-row mb-1 mt-1">
                                            <label class="col col-sm-4 col-form-label font-weight-bolder text-right"
                                                   for="new-comment-files"
                                            >
                                                Attachments:
                                            </label>
                                            <div class="col col-sm-8" id="new-comment-files-container">
                                                <input type="file" id="new-comment-files" multiple
                                                       accept="application/pdf"
                                                       class="form-control form-control-sm form-control-xs"
                                                >
                                            </div>
                                            <div class="col col-sm-12 text-center mt-2">
                                                <button type="submit" class="btn btn-sm btn-primary btn-block">
                                                    <span class="fas fa-save"></span>
                                                    Save
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </form>

                        </template>

                        <div class="overflow-auto crew-comment-height">
                            <div class="card text-smaller mt-2" v-for="crewActivityComment in crewActivity.crew_activity_comments" :key="crewActivityComment.id">
                                <div class="card-header p-1">
                                    <button class="btn btn-sm btn-xs btn-secondary float-right py-0 font-weight-bolder"
                                            @click="cancelEditCrewComment"
                                            v-if="editCrewActivityComment.id === crewActivityComment.id"
                                    >
                                        <span class="fas fa-ban"></span>
                                        Cancel
                                    </button>

                                    <button class="btn btn-sm btn-xs btn-danger float-right py-0 font-weight-bolder"
                                            @click="confirmDeleteCrewActivityComment(crewActivityComment.id)"
                                            v-else
                                    >
                                        <span class="fas fa-trash"></span>
                                        Delete
                                    </button>

                                    <button class="btn btn-sm btn-xs btn-warning float-right py-0 font-weight-bolder mr-2"
                                            @click="confirmUpdateCrewActivityComment(crewActivityComment)"
                                            name="editCrewActivityComment"
                                            :id="'editCrewActivityComment' + crewActivityComment.id"
                                    >
                                        {{ editCrewActivityComment.id === crewActivityComment.id ? 'Update' : 'Edit'}}
                                    </button>
                                </div>

                                <div class="card-body p-1">
                                <textarea class="form-control form-control-sm form-control-xs mb-2"
                                          :readonly="!(editCrewActivityComment.id === crewActivityComment.id)" rows="3"
                                          v-model="crewActivityComment.comment"
                                ></textarea>

                                    <div class="row">
                                        <div class="col col-sm-4">
                                            <div class="form-group form-row mb-1 mt-1">
                                                <label class="col col-sm-4 col-form-label font-weight-bolder text-right"
                                                       :for="'commentator' + crewActivityComment.id"
                                                >
                                                    Commented By:
                                                </label>

                                                <div class="col col-sm-8">
                                                    <input type="text" readonly
                                                           :id="'commentator' + crewActivityComment.id"
                                                           class="form-control form-control-sm form-control-xs"
                                                           :value="crewActivityComment.updatedBy"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col col-sm-8">
                                            <div class="row">
                                                <div class="col col-sm-3 pr-0" v-for="number in countAttachments(crewActivityComment.fileCount)" :key="number">
                                                    <button class="btn btn-link font-weight-bolder card-link"
                                                       @click.prevent="showCrewActivityCommentAttachment(crewActivityComment.id, number)"
                                                    >
                                                      {{ `File${number + 1}.pdf`}}
                                                    </button>
                                                    <button class="btn btn-sm btn-xs text-danger p-0 m-0"
                                                            v-if="editCrewActivityComment.id === crewActivityComment.id"
                                                            @click="confirmDeleteCrewActivityCommentAttachment(number)"
                                                            title="DELETE THIS ATTACHMENT"
                                                    >
                                                        <span class="fas fa-minus"></span>
                                                    </button>
                                                </div>

                                                <div class="col col-sm-1"
                                                     v-if="editCrewActivityComment.id === crewActivityComment.id"
                                                >
                                                    <button class="btn btn-sm text-success p-0 m-0"
                                                            title="Add Comment Attachment"
                                                            data-toggle="modal"
                                                            data-target="#add-crew-activity-comment-attachment"
                                                    >
                                                        <span class="fas fa-file-upload"></span>
                                                    </button>
                                                </div>

                                            </div>

                                        </div>
                                    </div>



                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="add-crew-activity-comment-attachment" tabindex="-1" role="dialog" aria-labelledby="add-crew-activity-comment-attachment-title" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title font-weight-bolder" id="add-crew-activity-comment-attachment-title">
                            Additional Crew Activity Comment Attachment
                        </h5>
                        <button type="button" class="close"
                                data-dismiss="modal" aria-label="Close"
                                id="close-add-crew-activity-comment-attachment"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body text-center text-small">
                        <form class="form-group form-row mb-1 mt-1" @submit.prevent="confirmAddCrewActivityCommentAttachment">
                            <label class="col col-sm-2 col-form-label font-weight-bolder text-left"
                                   for="add-crew-activity-comment-input-file"
                            >
                                Attachments:
                            </label>
                            <div class="col col-sm-7" id="add-crew-activity-comment-input-file-container">
                                <input type="file" id="add-crew-activity-comment-input-file" multiple
                                       required
                                       accept="application/pdf"
                                       class="form-control form-control-sm form-control-xs"
                                >
                            </div>
                            <div class="col col-sm-3">
                                <button type="submit" class="btn btn-sm btn-primary">
                                    <span class="fas fa-save"></span>
                                    Save
                                </button>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import { vueAppMixin } from "@/mixins/vueAppMixin";
import { formMixin } from "@/mixins/formMixin";
import { dataMixin } from "@/mixins/dataMixin";
import { gateMixin } from "@/mixins/gateMixin";
import {FileService} from "@/services/FileService";

export default {

    name: "CrewActivityComment",

    mixins:[ vueAppMixin, formMixin, dataMixin, gateMixin ],

    data() {
        return {
            newComment: '',
            newCrewActivityCommentErrors: {},
            editCrewActivityComment: {},
            editCrewActivityCommentErrors: {},
            originalCrewActivityComment: {},
            crewActivityCommentAttachment: ''
        }
    },

    methods: {
        ...mapActions([
            'addCrewActivityComment',
            'getCrewActivityCommentAttachment',
            'addCrewActivityCommentAttachment',
            'deleteCrewActivityCommentAttachment',
            'updateCrewCommentActivity',
            'deleteCrewActivityComment'
        ]),

        async confirmAddCrewActivityComment() {
            if(await this.confirmCreateAlert()) {
                let formData = new FormData();
                formData.append('crew_activity_id', this.crewActivity.id);
                formData.append('comment', this.newComment);

                let input = document.getElementById('new-comment-files');
                if (input.files.length) {
                    for(let i=0; i<input.files.length; i++) {
                        formData.append(`commentFiles[]`, input.files[i]);
                    }
                }
                let newCrewActivityComment = await this.addCrewActivityComment(formData);

                if(newCrewActivityComment) {
                    if(newCrewActivityComment.errors) {
                        this.newCrewActivityCommentErrors = newCrewActivityComment.errors;
                    } else {

                        this.successAlert('Crew Activity Comment Successfully Added', 'CREATE');
                        this.newComment = '';
                        this.refreshInputFile('new-comment-files-container');
                    }
                }
            }
        },

        countAttachments(fileCount) {
            let attachments = [];
            attachments = [...Array(fileCount).keys()];
            return attachments;
        },

        async confirmUpdateCrewActivityComment(crewActivityComment) {
            if(this.editCrewActivityComment.id === crewActivityComment.id) {
                let params = {
                    crewActivityCommentId: this.editCrewActivityComment.id,
                    comment: this.editCrewActivityComment.comment
                }
                if(await this.confirmUpdate()) {
                    let updatedCrewActivityComment = await this.updateCrewCommentActivity(params);
                    if(updatedCrewActivityComment) {
                        if(updatedCrewActivityComment.errors) {
                            this.editCrewActivityCommentErrors = updatedCrewActivityComment.errors;
                        } else {
                            this.editCrewActivityComment = {};
                            this.editCrewActivityCommentErrors = {};
                            this.originalCrewActivityComment = {};
                            this.successAlert('Comment Successfully Updated', 'UPDATE');
                            this.cancelEditCrewComment();
                        }
                    } else {
                        this.errorAlert('Comment Failed to Update', 'UPDATE');
                    }

                }
            } else {
                document.getElementsByName('editCrewActivityComment').forEach(editButton => {
                    editButton.disabled = true;
                });
                document.getElementById('editCrewActivityComment' + crewActivityComment.id).disabled = false;
                this.editCrewActivityComment = crewActivityComment;
                this.originalCrewActivityComment = Object.assign({}, crewActivityComment);
            }
        },

        cancelEditCrewComment() {
            document.getElementsByName('editCrewActivityComment').forEach(editbutton => {
                editbutton.disabled = false;
            });
            this.undoEditCrewActivityComment();
            this.editCrewActivityComment = {};
        },

        undoEditCrewActivityComment() {
            let index = this.crewActivity.crew_activity_comments.findIndex(crewActivityComment => {
                return crewActivityComment.id === this.editCrewActivityComment.id;
            });
            this.crewActivity.crew_activity_comments.splice(index, 1, this.originalCrewActivityComment);
        },

        async showCrewActivityCommentAttachment(crewActivityCommentId, number) {
            this.crewActivityCommentAttachment = ''
            let params = {
                crewActivityCommentId: crewActivityCommentId,
                number: number
            };

            const crewActivityCommentAttachment = await this.getCrewActivityCommentAttachment(params);

            FileService.viewFile(crewActivityCommentAttachment)
        },

        async confirmAddCrewActivityCommentAttachment() {
            if(await this.confirmCreateAlert('Are you sure you want to add this attachments?')) {
                let formData = new FormData();
                formData.append('crewActivityCommentId', this.editCrewActivityComment.id);
                let input = document.getElementById('add-crew-activity-comment-input-file');
                if (input.files.length) {
                    for(let i=0; i<input.files.length; i++) {
                        formData.append(`commentFiles[]`, input.files[i]);
                    }
                }

                let addedCrewActivityCommentAttachment = await this.addCrewActivityCommentAttachment(formData);
                if(addedCrewActivityCommentAttachment) {
                    let index = this.crewActivity.crew_activity_comments.findIndex(crewActivityComment => {
                        return crewActivityComment.id === this.editCrewActivityComment.id;
                    });
                    this.crewActivity.crew_activity_comments[index].fileCount += input.files.length;
                    this.successAlert('Attachments Successfully Added', 'UPLOAD');
                    document.getElementById('close-add-crew-activity-comment-attachment').click();
                    this.refreshInputFile('add-crew-activity-comment-input-file-container');
                } else {
                    this.errorAlert('Attachments Failed to Upload', 'UPLOAD');
                }

            }
        },

        async confirmDeleteCrewActivityCommentAttachment(number) {
            if(await this.confirmDeleteAlert()) {
                let params = {
                    crewActivityCommentId: this.editCrewActivityComment.id,
                    number: number
                };
                let deletedCrewActivityCommentAttachment = await this.deleteCrewActivityCommentAttachment(params);
                if(deletedCrewActivityCommentAttachment) {
                    let index = this.crewActivity.crew_activity_comments.findIndex(crewActivityComment => {
                        return crewActivityComment.id === this.editCrewActivityComment.id;
                    });
                    this.crewActivity.crew_activity_comments[index].fileCount--;
                    this.successAlert('Attachment Successfully Deleted', 'DELETE');
                } else {
                    this.errorAlert('Crew Comment Attachment Failed to Delete', 'DELETE');
                }
            }
        },

        async confirmDeleteCrewActivityComment(crewActivityCommentId) {
            if(await this.confirmDeleteAlert()) {
                let params = {
                    crewActivityCommentId: crewActivityCommentId
                };
                let deletedCrewActivityComment = this.deleteCrewActivityComment(params);
                if(deletedCrewActivityComment && !deletedCrewActivityComment.errors) {
                    this.successAlert('Comment Successfully Deleted', 'DELETE');
                }
            }
        }

    },

    computed: {
        ...mapGetters([ 'crewActivity' ]),
    }

}
</script>

<style scoped>
.modal-lg, .modal-xl {
    max-width: 1150px;
    max-height: 2000px;
}
</style>